import { styled } from '@mui/system';

export const TrendingNowTagWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  width: '100%',
  position: 'relative', // CRITICAL FIX: anchors absolutely positioned nav buttons
}));

export const TrendingNowTag = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  overflowX: 'auto',
  overflowY: 'hidden',
  flex: 1,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(0.5),
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const TrendingNowContainer = styled('div')(() => ({
  overflow: 'hidden',
}));
